import React, { useState, useRef, useEffect } from "react";
import { sixYardAxios } from "../../sixYardAxios";
import { connect } from 'react-redux';
import HeroSection from '../../components/tournaments/heroSection/heroSection';
import TournamentsCard from '../../components/tournaments/tournamentsCard/tournamentsCard';
import Form from '../../components/tournaments/form/form';
import Checkout from '../../components/tournaments/checkout/checkout';
import classes from '../../components/tournaments/tournaments.module.css';
import LoginModal from '../../components/containers/loginModal/loginModal';

const Tournaments = (props) => {
    const createTournamentRef = useRef(null);
    const [showCheckout, setShowCheckout] = useState(false);
    const [upcomingTournaments, setUpcomingTournaments] = useState([]);
    const [previousTournaments, setPreviousTournaments] = useState([]);
    const [services, setServices] = useState([]);
    const [dates, setDates] = useState([]);
    const [tournamentId, setTournamentId] = useState(null);
    const [amount, setAmount] = useState(null);
    const [loyaltyPoints, setLoyaltyPoints] = useState(null);
    const [selectedServices, setSelectedServices] = useState(null);
    const [showLoginForm, setShowLoginForm] = useState(false);
    
    // Use Redux language state instead of localStorage
    const isEnglish = props.selectedLanguage === 1;

    useEffect(() => {
        fetchTournamentsList();
    }, []);
    
    // Add effect to refetch data when language changes
    useEffect(() => {
        fetchTournamentsList();
    }, [props.selectedLanguage]);
    
    useEffect(() => {
        props.isAuthenticated && setShowLoginForm(false);
    }, [props.isAuthenticated]);
    
    const fetchTournamentsList = async () => {
        try {
            // Include language parameter in API request
            const lang = props.selectedLanguage;
            const res = await sixYardAxios.get(`/tournaments?lang=${lang}`);
            setUpcomingTournaments(res.data.data.data.upcoming);
            setPreviousTournaments(res.data.data.data.previous);
            setServices(res.data.data.data.available_services);
        } catch (error) { }
    };
    
    return (
        <div className={classes.Container}>
            {!showCheckout ? <div>
                <HeroSection createTournamentRef={createTournamentRef} />
                {upcomingTournaments.length > 0 && 
                <TournamentsCard 
                    tournaments={upcomingTournaments} 
                    title={isEnglish 
                        ? 'UPCOMING TOURNAMENTS' 
                        : 'البطولات القادمة'}
                    button={isEnglish 
                        ? 'REGISTER NOW' 
                        : 'سجل الآن'} 
                />}
                {previousTournaments.length > 0 && 
                <TournamentsCard 
                    tournaments={previousTournaments} 
                    title={isEnglish 
                        ? 'PREVIOUS TOURNAMENTS' 
                        : 'البطولات السابقة'} 
                    old
                    whiteBackground 
                    button={isEnglish 
                        ? 'VIEW DETAILS' 
                        : 'عرض التفاصيل'} 
                />}
                <Form setShowCheckout={setShowCheckout} ref={createTournamentRef} setDates={setDates}
                    setTournamentId={setTournamentId} services={services}
                    setAmount={setAmount} setLoyaltyPoints={setLoyaltyPoints} setSelectedServices={setSelectedServices}
                    isAuthenticated={props.isAuthenticated}
                    setShowLoginForm={setShowLoginForm} />
            </div>
                : <Checkout setShowCheckout={setShowCheckout} tournamentId={tournamentId} dates={dates}
                    amount={amount} loyaltyPoints={loyaltyPoints} selectedServices={selectedServices}/>}
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} currentPath={window.location.pathname} />}
        </div>
    )
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.token !== null,
    selectedLanguage: state.home.selected_language
});

export default connect(mapStateToProps)(Tournaments);